<!-- eslint-disable vue/prop-name-casing -->
<script setup>
import HawkEntityInput from './hawk-entity-input.vue';

defineProps({
  asset_id: {
    type: String,
    default: null,
  },
  selectedAssets: {
    type: Array,
  },
  updateFormData:{
    type: Function
  },
  options: {
    type: Object,
  },
  tag_class: {
    type: String,
    default: 'max-w-[200px]',
  },
  multi: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['open', 'change']);
</script>

<template>
  <HawkEntityInput
  :update-form-data="updateFormData"
    type="roles"
    v-bind="{
      asset_id,
      selectedAssets,
      options,
      tag_class,
      multi,
    }"
    @open="emit('open', $event)"
    @change="emit('change', $event)"
  >
    <template v-if="$slots.label" #label>
      <slot name="label" />
    </template>
  </HawkEntityInput>
</template>
